import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-under-offer',
  templateUrl: './listing-under-offer.component.html',
  styleUrls: ['./listing-under-offer.component.scss']
})
export class ListingUnderOfferComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }
}
